<template>
    <div>
        <div class="form-group">
            <label class="fw-bold">
                <localized-text localizedKey="Articoli" text="Articoli"></localized-text>
            </label>
            <div class="scrollListContainer">
                <div class="scrollBox">
                    <div class="scrollListItem" v-for="(item, i) in cart.offers" :key="item.offer.identifier">
                        {{item.offer.name}} x {{item.quantity}}
                    </div>
                </div>
            </div>
        </div>
        <form-answers-viewer :answers="cart.formAnswers"></form-answers-viewer>
    </div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import * as VM from '@/viewmodel';

@Options({})
export default class shoppingCartViewer extends Vue {

    @Prop() cart: OM.ShoppingCart;

    hasForm: boolean = false;

    created(){
        this.init();
    }

    @Watch('cart')
    init(){
        if(this.cart.formAnswers){
            this.hasForm = Object.keys(this.cart.formAnswers).length > 0;
        } else {
            this.hasForm = false;
        }
    }

}

</script>
